import { api } from '@wix/promote-analytics-adapter';

let pageViewReported = false;
let deferringPageViewReport = false;

const isCookieConsentGiven = () => {
  const { policy } = window.consentPolicyManager?.getCurrentConsentPolicy() ?? {
    policy: { analytics: true, functional: true },
  };

  return policy.analytics && policy.functional;
};

export const trackEvent: typeof api.trackEvent = (
  eventName: string,
  ...args: any[]
) => {
  if (!isCookieConsentGiven()) {
    if (
      eventName === 'PageView' &&
      !pageViewReported &&
      !deferringPageViewReport
    ) {
      deferringPageViewReport = true;

      const handler = () => {
        if (!isCookieConsentGiven()) {
          return;
        }

        window.removeEventListener('consentPolicyChanged', handler);

        pageViewReported = true;
        deferringPageViewReport = false;

        setTimeout(() => {
          api.trackEvent('PageView', ...args);
        });
      };

      window.addEventListener('consentPolicyChanged', handler);
    }

    return;
  }

  if (eventName === 'PageView') {
    pageViewReported = true;
  }

  return api.trackEvent(eventName, ...args);
};

export const resetTrackEvent = () => {
  pageViewReported = false;
  deferringPageViewReport = false;
};
